export default {
  currentPromotion: state => state.current
}
